"use strict";

console.log("%c", "padding:18px 80px;line-height:80px;background:url('http://www.sunlands.com/img/logo.png') 100% no-repeat;");
console.log("%c", "padding:80px 190px;line-height:110px;background:url('http://www.sunlands.com/img/feTeam.png') left center  no-repeat;background-size:50%;");
console.log("%c 招聘信息:", "color:#2c2c2c;" + "font-family: 'Microsoft Yahei';" + "line-height:30px;" + "font-size:22px");
console.log("%c 566A5Y6G6K+35Y+R6YCB6IezOiB5YW55dUBzdW5sYW5kcy5jb20gIOmCruS7tuivt+azqOaYjiBmcm9tIGNvbnNvbGUg ", "color:#2c2c2c;" + "font-family: 'Microsoft Yahei';" + "line-height:20px;" + "font-size:16px");


//////////////////
// WEBPACK FOOTER
// ./src/js/common/log.js
// module id = 14
// module chunks = 0 2 3 4 5 6 7 8 10 11 12